import { ProcedureIndexDisplayStatus } from "../interfaces";

/** The server's `limitQueryNumber` caps at 100 (api/app/shared/schemas/shared.schemas.ts) — a larger
 * default here would make every list call a 400. */
export const PROCEDURE_INDEX_DEFAULT_LIMIT = 20;

/** What `getProcedureIndexStatusSaga` reports on `loadError` — same reasoning as the eval run list's
 * own generic load error: the failure payload's `.message` is either the API's literal error text or
 * an AxiosError's, neither fit for an admin screen. */
export const PROCEDURE_INDEX_LOAD_ERROR = "Something went wrong loading the procedure index status. Please try again.";

/** Shared between the status-count summary and the table's status column — both need the same
 * human-readable label for a bucket, and the enum's own string value ("never_indexed") isn't the
 * display casing. */
export const INDEX_STATUS_LABELS: Record<ProcedureIndexDisplayStatus, string> = {
  [ProcedureIndexDisplayStatus.INDEXED]: "Indexed",
  [ProcedureIndexDisplayStatus.SKIPPED]: "Skipped",
  [ProcedureIndexDisplayStatus.FAILED]: "Failed",
  [ProcedureIndexDisplayStatus.REMOVED]: "Removed",
  [ProcedureIndexDisplayStatus.NEVER_INDEXED]: "Never indexed",
  [ProcedureIndexDisplayStatus.NOT_APPLICABLE]: "Not applicable",
};

/** Display order for both the status-count summary and the badge legend — actionable states first. */
export const INDEX_STATUS_ORDER: ProcedureIndexDisplayStatus[] = [
  ProcedureIndexDisplayStatus.FAILED,
  ProcedureIndexDisplayStatus.REMOVED,
  ProcedureIndexDisplayStatus.SKIPPED,
  ProcedureIndexDisplayStatus.NEVER_INDEXED,
  ProcedureIndexDisplayStatus.INDEXED,
  ProcedureIndexDisplayStatus.NOT_APPLICABLE,
];
